/* eslint-disable import/no-anonymous-default-export */
import Notification from "../../components/shared/Notification";
import request from "../../helpers/request";

export const updateCategory = async ({ prevCategory, category }) => {
  try {
    const token = localStorage.getItem("token");
    return await request(token)
      .post("/establishmentcategory/update", {
        oldState: prevCategory,
        newState: category,
      })
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }

        return data;
      });
  } catch (error) {
    return Notification(
      "Error",
      error.response.data.message || "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const createCategory = async (data) => {
  try {
    const token = localStorage.getItem("token");
    return await request(token)
      .post("/establishmentcategory/create", { category: data })
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        Notification("Successfully created category!", "", "success");

        return data;
      });
  } catch (error) {
    return Notification(
      "Error",
      error.response.data.message || "Some went wrong! Please try again later!",
      "error"
    );
  }
};

export const getAllCategory = async (data) => {
  try {
    const token = localStorage.getItem("token");
    return await request(token)
      .post("/establishmentcategory/all", { category: data })
      .then(({ data }) => {
        if (data?.errorMessage || data?.errors || data?.error) {
          Notification(
            "Error",
            data?.errorMessage ||
              data?.errors ||
              "Something went wrong. Please check your information!",
            "error"
          );
        }
        Notification("Successfully created category!", "", "success");

        return data;
      });
  } catch (error) {
    return Notification(
      "Error",
      error.response.data.message || "Some went wrong! Please try again later!",
      "error"
    );
  }
};
